
require('../app/news.coffee')
require('../app/priority_icons.coffee')
require('../app/image_resizer.coffee')
require('../app/home_page_switch.coffee')
require('../app/timer.coffee')
require('../app/home_slider.coffee')

window.homePageInitFlag = false

pageInit = ->
  new window.News()
  new window.PriorityIcons()
  new window.ImageResizer()
  new window.HomePageSwitch()
  new window.Timer()
  new window.HomeSlider()

$(document).ready ->
  if window.homePageInitFlag != true
    pageInit()
  window.homePageInitFlag = true




// WEBPACK FOOTER //
// ./assets/javascripts/pages/home.coffee